import { useNavigate } from "react-router-dom";
import "./nuvemTreinamento.css";

const NuvemTreinamento = () => {
  const navigate = useNavigate();

  function abrirNuvem() {
    navigate("/nuvem"); // depois vamos criar essa tela
  }

  return (
    <div className="nuvem-card" onClick={abrirNuvem}>
      <div className="nuvem-header">
        <h3>NUVEM TREINAMENTO</h3>
      </div>

      <div className="nuvem-body">
        <div className="icone-nuvem">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 24 24"
            fill="#2d6cdf"
          >
            <path d="M19 18H6a4 4 0 010-8 5 5 0 019.9-1.5A4 4 0 0119 18zm-7-7l-4 4h3v4h2v-4h3l-4-4z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default NuvemTreinamento;
